export type EventCallback<T = any> = (data: T) => void;

export interface IEventBus {
  on<T = any>(event: string, callback: EventCallback<T>): void;
  off(event: string, callback: EventCallback): void;
  emit<T = any>(event: string, data?: T): void;
  once<T = any>(event: string, callback: EventCallback<T>): void;
  clear(): void;
}

// Event types
export interface ComponentEvents {
  'capture-completed': any;
  'ready': boolean;
  'camera-changed': string;
  'detection-updated': any[];
  'state-changed': any;
  'error': Error;
}